<template>
  <div class="content">
    <vue-snotify></vue-snotify>
    <div class="content">
      <div class="content-wrapper">
        <div class="content-body">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "Senha.vue"
}
</script>